var NameRegistrationAuthorities_1, QCStatements_1;
import { __decorate } from "tslib";
import { id_pe, GeneralName } from "@peculiar/asn1-x509";
import { AsnTypeTypes, AsnType, AsnArray, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { id_qcs } from "../object_identifiers";
export const id_pe_qcStatements = `${id_pe}.3`;
export class QCStatement {
    constructor() {
        this.statementId = "";
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], QCStatement.prototype, "statementId", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Any, optional: true })
], QCStatement.prototype, "statementInfo", void 0);
export const id_qcs_pkixQCSyntax_v1 = `${id_qcs}.1`;
export const id_qcs_pkixQCSyntax_v2 = `${id_qcs}.2`;
let NameRegistrationAuthorities = NameRegistrationAuthorities_1 = class NameRegistrationAuthorities extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, NameRegistrationAuthorities_1.prototype);
    }
};
NameRegistrationAuthorities = NameRegistrationAuthorities_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: GeneralName })
], NameRegistrationAuthorities);
export { NameRegistrationAuthorities };
export class SemanticsInformation {
    constructor(params = {}) {
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier, optional: true })
], SemanticsInformation.prototype, "semanticsIdentifier", void 0);
__decorate([
    AsnProp({ type: NameRegistrationAuthorities, optional: true })
], SemanticsInformation.prototype, "nameRegistrationAuthorities", void 0);
let QCStatements = QCStatements_1 = class QCStatements extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, QCStatements_1.prototype);
    }
};
QCStatements = QCStatements_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: QCStatement })
], QCStatements);
export { QCStatements };
